import Router from 'next/router'
import {
  compose,
  withHandlers,
  lifecycle,
  pure,
  withProps,
  withStateHandlers
} from 'recompose'
import { reduxForm, SubmissionError } from 'redux-form'
import { connect } from 'react-redux'
import _get from 'lodash/get'

import { sendForgotPassword } from '../reducers/user'
import { Forgot } from '../components/Forgot'
import { withInitialData } from '../components/hoc'

const mapStateToProps = state => {
  return {
    loading: state.user.loading
  }
}

const mapDispatchToProps = dispatch => {
  return {
    sendForgotPassword: (...data) => dispatch(sendForgotPassword(...data))
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps({
    title: 'common:reset-password',
    contentImage: ''
  }),
  withInitialData,
  lifecycle({
    componentWillReceiveProps(nextProps) {
      if (nextProps.isAuthenticated) {
        Router.push('/')
      }
    }
  }),
  withStateHandlers({
    submitResultInfo: null
  },
  {
    setSubmitResultInfo: () => (value = null) => ({
      submitResultInfo: value
    })
  }),
  withHandlers({
    _handleSubmit: props => data => {
      props.setSubmitResultInfo()
      return props.sendForgotPassword(data)
        .then(() => {
          props.createNotification({
            type: 'success',
            message: `${props.t('common:reset-password-email-response')}`
          })
          Router.push('/')
        })
        .catch(err => {
          if (err.response.status !== 401) {
            const formError = _get(err, 'response.data.message') ?
              props.t(_get(err, 'response.data.message')) : props.t('common:server-error')

            props.createNotification({
              type: 'error',
              message: props.t(formError)
            })
            throw new SubmissionError({
              _error: formError
            })
          } else {
            props.setSubmitResultInfo(_get(err, 'response.data.message'))
          }
        })
    }
  }),
  reduxForm({
    destroyOnUnmount: false,
    form: 'forgot'
  }),
  pure
)(Forgot)



// WEBPACK FOOTER //
// ./pages/forgot.js